export default __webpack_public_path__ + "static/media/ct213-7.01fb4900.png";